import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, Logger } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import {AbstractDataServiceV2} from 'src/app/modules/core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from 'src/app/store/core/url/customizeHttpUrlGenerator';
import {InsoleCadProcessModel} from "../../../api/model/insoleCadProcess.model";
import {InsoleCadProcessConverter} from "../../../api/model/insoleCadProcess.converter";

@Injectable({
    providedIn: 'root'
})
export class InsoleCadProcessDataService extends AbstractDataServiceV2<InsoleCadProcessModel, InsoleCadProcessConverter> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: CustomizeHttpUrlGenerator,
        logger: Logger,
        config: DefaultDataServiceConfig,
        converter: InsoleCadProcessConverter) {
        super('InsoleCadProcess', http, httpUrlGenerator, logger, config, converter);
    }
}
